/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AlertCleanupResponse } from '../models';
// @ts-ignore
import type { AlertResolutionRequest } from '../models';
// @ts-ignore
import type { AlertResolutionResponse } from '../models';
// @ts-ignore
import type { AlertStatistics } from '../models';
// @ts-ignore
import type { DeliveryAlert } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { MessageResponse } from '../models';
// @ts-ignore
import type { PagedWebhookDeliveryResponse } from '../models';
// @ts-ignore
import type { PartnerHealthCheckTriggerResponse } from '../models';
// @ts-ignore
import type { SystemHealthCheck } from '../models';
// @ts-ignore
import type { SystemHealthCheckTriggerResponse } from '../models';
// @ts-ignore
import type { WebhookDeliveryAttemptDetailResponse } from '../models';
// @ts-ignore
import type { WebhookDeliveryAttemptHistoryResponse } from '../models';
// @ts-ignore
import type { WebhookDeliveryDetailResponse } from '../models';
// @ts-ignore
import type { WebhookEndpointHealthCheck } from '../models';
// @ts-ignore
import type { WebhookMonitoringDashboard } from '../models';
/**
 * WebhookMonitoringApi - axios parameter creator
 * @export
 */
export const WebhookMonitoringApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Remove resolved alerts older than 24 hours and return before/after statistics.
         * @summary Cleanup resolved webhook alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanupWebhookAlerts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/webhook-monitoring/alerts/cleanup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clear cached health check results to ensure subsequent checks recompute metrics.
         * @summary Clear webhook health check caches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearWebhookHealthCheckCache: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/webhook-monitoring/health-check/cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run a detailed health assessment for a partner webhook endpoint including connectivity, latency, reliability, and volume checks.
         * @summary Perform partner webhook health check
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerWebhookHealthCheck: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getPartnerWebhookHealthCheck', 'partnerId', partnerId)
            const localVarPath = `/admin/webhook-monitoring/partners/{partnerId}/health-check`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Execute a comprehensive health check across all partner webhook endpoints including aggregated metrics and system issues.
         * @summary Perform system-wide webhook health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemWebhookHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/webhook-monitoring/system/health-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve aggregated statistics for active webhook alerts across the system.
         * @summary Get webhook alert statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookAlertStatistics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/webhook-monitoring/alerts/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed information about a specific webhook delivery attempt, including comprehensive troubleshooting information, error details, and retry scheduling.
         * @summary Get webhook delivery attempt details
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} deliveryId Webhook delivery ID (ULID)
         * @param {string} attemptId Delivery attempt ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookDeliveryAttemptDetails: async (partnerId: string, deliveryId: string, attemptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getWebhookDeliveryAttemptDetails', 'partnerId', partnerId)
            // verify required parameter 'deliveryId' is not null or undefined
            assertParamExists('getWebhookDeliveryAttemptDetails', 'deliveryId', deliveryId)
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('getWebhookDeliveryAttemptDetails', 'attemptId', attemptId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/deliveries/{deliveryId}/attempts/{attemptId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"deliveryId"}}`, encodeURIComponent(String(deliveryId)))
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed information about a specific webhook delivery, including all delivery attempts and response data.
         * @summary Get webhook delivery details
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} deliveryId Webhook delivery ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookDeliveryDetails: async (partnerId: string, deliveryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getWebhookDeliveryDetails', 'partnerId', partnerId)
            // verify required parameter 'deliveryId' is not null or undefined
            assertParamExists('getWebhookDeliveryDetails', 'deliveryId', deliveryId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/deliveries/{deliveryId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"deliveryId"}}`, encodeURIComponent(String(deliveryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve consolidated monitoring dashboard data combining health checks, active alerts, and summary metrics.
         * @summary Get webhook monitoring dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookMonitoringDashboard: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/webhook-monitoring/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all active webhook delivery alerts including severity, affected endpoints, and descriptive metadata.
         * @summary List active webhook delivery alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveWebhookAlerts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/webhook-monitoring/alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve active delivery alerts scoped to a specific partner webhook configuration.
         * @summary List active alerts for partner webhook
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerWebhookAlerts: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('listPartnerWebhookAlerts', 'partnerId', partnerId)
            const localVarPath = `/admin/webhook-monitoring/partners/{partnerId}/alerts`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of webhook delivery attempts for the authenticated partner. Results are sorted by creation date in descending order (most recent first). Uses standard page-based pagination.
         * @summary List webhook deliveries for partner
         * @param {string} partnerId Partner ID (ULID)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {string} [webhookId] Filter by specific webhook configuration ID
         * @param {ListWebhookDeliveriesStatusEnum} [status] Filter by delivery status
         * @param {string} [eventType] Filter by webhook event type
         * @param {string} [from] Filter deliveries from this date (ISO 8601 format)
         * @param {string} [to] Filter deliveries until this date (ISO 8601 format)
         * @param {string} [paymentSessionId] Filter by the payment session the webhook event is about
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebhookDeliveries: async (partnerId: string, page?: number, size?: number, webhookId?: string, status?: ListWebhookDeliveriesStatusEnum, eventType?: string, from?: string, to?: string, paymentSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('listWebhookDeliveries', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/deliveries`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (webhookId !== undefined) {
                localVarQueryParameter['webhookId'] = webhookId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['eventType'] = eventType;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (paymentSessionId !== undefined) {
                localVarQueryParameter['paymentSessionId'] = paymentSessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a complete history of delivery attempts for a specific webhook delivery. Attempts are ordered chronologically (latest first) with comprehensive troubleshooting information.
         * @summary List webhook delivery attempts
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} deliveryId Webhook delivery ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebhookDeliveryAttempts: async (partnerId: string, deliveryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('listWebhookDeliveryAttempts', 'partnerId', partnerId)
            // verify required parameter 'deliveryId' is not null or undefined
            assertParamExists('listWebhookDeliveryAttempts', 'deliveryId', deliveryId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/deliveries/{deliveryId}/attempts`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"deliveryId"}}`, encodeURIComponent(String(deliveryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve an active webhook alert with optional resolution details for audit trails.
         * @summary Resolve webhook delivery alert
         * @param {string} alertId Alert ID (ULID)
         * @param {AlertResolutionRequest} [alertResolutionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveWebhookAlert: async (alertId: string, alertResolutionRequest?: AlertResolutionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertId' is not null or undefined
            assertParamExists('resolveWebhookAlert', 'alertId', alertId)
            const localVarPath = `/admin/webhook-monitoring/alerts/{alertId}/resolve`
                .replace(`{${"alertId"}}`, encodeURIComponent(String(alertId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alertResolutionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Force a fresh partner webhook health check, bypassing cached results.
         * @summary Trigger partner webhook health check
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerPartnerWebhookHealthCheck: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('triggerPartnerWebhookHealthCheck', 'partnerId', partnerId)
            const localVarPath = `/admin/webhook-monitoring/partners/{partnerId}/health-check/trigger`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Force a fresh system-wide webhook health check, clearing cached aggregates.
         * @summary Trigger system-wide webhook health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSystemWebhookHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/webhook-monitoring/system/health-check/trigger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookMonitoringApi - functional programming interface
 * @export
 */
export const WebhookMonitoringApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookMonitoringApiAxiosParamCreator(configuration)
    return {
        /**
         * Remove resolved alerts older than 24 hours and return before/after statistics.
         * @summary Cleanup resolved webhook alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cleanupWebhookAlerts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertCleanupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cleanupWebhookAlerts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.cleanupWebhookAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clear cached health check results to ensure subsequent checks recompute metrics.
         * @summary Clear webhook health check caches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearWebhookHealthCheckCache(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearWebhookHealthCheckCache(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.clearWebhookHealthCheckCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run a detailed health assessment for a partner webhook endpoint including connectivity, latency, reliability, and volume checks.
         * @summary Perform partner webhook health check
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerWebhookHealthCheck(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookEndpointHealthCheck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerWebhookHealthCheck(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.getPartnerWebhookHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Execute a comprehensive health check across all partner webhook endpoints including aggregated metrics and system issues.
         * @summary Perform system-wide webhook health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSystemWebhookHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemHealthCheck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSystemWebhookHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.getSystemWebhookHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve aggregated statistics for active webhook alerts across the system.
         * @summary Get webhook alert statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookAlertStatistics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookAlertStatistics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.getWebhookAlertStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed information about a specific webhook delivery attempt, including comprehensive troubleshooting information, error details, and retry scheduling.
         * @summary Get webhook delivery attempt details
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} deliveryId Webhook delivery ID (ULID)
         * @param {string} attemptId Delivery attempt ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookDeliveryAttemptDetails(partnerId: string, deliveryId: string, attemptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookDeliveryAttemptDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookDeliveryAttemptDetails(partnerId, deliveryId, attemptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.getWebhookDeliveryAttemptDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed information about a specific webhook delivery, including all delivery attempts and response data.
         * @summary Get webhook delivery details
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} deliveryId Webhook delivery ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookDeliveryDetails(partnerId: string, deliveryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookDeliveryDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookDeliveryDetails(partnerId, deliveryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.getWebhookDeliveryDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve consolidated monitoring dashboard data combining health checks, active alerts, and summary metrics.
         * @summary Get webhook monitoring dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookMonitoringDashboard(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookMonitoringDashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookMonitoringDashboard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.getWebhookMonitoringDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all active webhook delivery alerts including severity, affected endpoints, and descriptive metadata.
         * @summary List active webhook delivery alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActiveWebhookAlerts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliveryAlert>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActiveWebhookAlerts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.listActiveWebhookAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve active delivery alerts scoped to a specific partner webhook configuration.
         * @summary List active alerts for partner webhook
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPartnerWebhookAlerts(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliveryAlert>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPartnerWebhookAlerts(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.listPartnerWebhookAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of webhook delivery attempts for the authenticated partner. Results are sorted by creation date in descending order (most recent first). Uses standard page-based pagination.
         * @summary List webhook deliveries for partner
         * @param {string} partnerId Partner ID (ULID)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {string} [webhookId] Filter by specific webhook configuration ID
         * @param {ListWebhookDeliveriesStatusEnum} [status] Filter by delivery status
         * @param {string} [eventType] Filter by webhook event type
         * @param {string} [from] Filter deliveries from this date (ISO 8601 format)
         * @param {string} [to] Filter deliveries until this date (ISO 8601 format)
         * @param {string} [paymentSessionId] Filter by the payment session the webhook event is about
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWebhookDeliveries(partnerId: string, page?: number, size?: number, webhookId?: string, status?: ListWebhookDeliveriesStatusEnum, eventType?: string, from?: string, to?: string, paymentSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedWebhookDeliveryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWebhookDeliveries(partnerId, page, size, webhookId, status, eventType, from, to, paymentSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.listWebhookDeliveries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a complete history of delivery attempts for a specific webhook delivery. Attempts are ordered chronologically (latest first) with comprehensive troubleshooting information.
         * @summary List webhook delivery attempts
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} deliveryId Webhook delivery ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWebhookDeliveryAttempts(partnerId: string, deliveryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookDeliveryAttemptHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWebhookDeliveryAttempts(partnerId, deliveryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.listWebhookDeliveryAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolve an active webhook alert with optional resolution details for audit trails.
         * @summary Resolve webhook delivery alert
         * @param {string} alertId Alert ID (ULID)
         * @param {AlertResolutionRequest} [alertResolutionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveWebhookAlert(alertId: string, alertResolutionRequest?: AlertResolutionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertResolutionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveWebhookAlert(alertId, alertResolutionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.resolveWebhookAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Force a fresh partner webhook health check, bypassing cached results.
         * @summary Trigger partner webhook health check
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerPartnerWebhookHealthCheck(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerHealthCheckTriggerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerPartnerWebhookHealthCheck(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.triggerPartnerWebhookHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Force a fresh system-wide webhook health check, clearing cached aggregates.
         * @summary Trigger system-wide webhook health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerSystemWebhookHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemHealthCheckTriggerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerSystemWebhookHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookMonitoringApi.triggerSystemWebhookHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhookMonitoringApi - factory interface
 * @export
 */
export const WebhookMonitoringApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookMonitoringApiFp(configuration)
    return {
        /**
         * Remove resolved alerts older than 24 hours and return before/after statistics.
         * @summary Cleanup resolved webhook alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanupWebhookAlerts(options?: RawAxiosRequestConfig): AxiosPromise<AlertCleanupResponse> {
            return localVarFp.cleanupWebhookAlerts(options).then((request) => request(axios, basePath));
        },
        /**
         * Clear cached health check results to ensure subsequent checks recompute metrics.
         * @summary Clear webhook health check caches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearWebhookHealthCheckCache(options?: RawAxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.clearWebhookHealthCheckCache(options).then((request) => request(axios, basePath));
        },
        /**
         * Run a detailed health assessment for a partner webhook endpoint including connectivity, latency, reliability, and volume checks.
         * @summary Perform partner webhook health check
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerWebhookHealthCheck(partnerId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookEndpointHealthCheck> {
            return localVarFp.getPartnerWebhookHealthCheck(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute a comprehensive health check across all partner webhook endpoints including aggregated metrics and system issues.
         * @summary Perform system-wide webhook health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemWebhookHealthCheck(options?: RawAxiosRequestConfig): AxiosPromise<SystemHealthCheck> {
            return localVarFp.getSystemWebhookHealthCheck(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve aggregated statistics for active webhook alerts across the system.
         * @summary Get webhook alert statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookAlertStatistics(options?: RawAxiosRequestConfig): AxiosPromise<AlertStatistics> {
            return localVarFp.getWebhookAlertStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed information about a specific webhook delivery attempt, including comprehensive troubleshooting information, error details, and retry scheduling.
         * @summary Get webhook delivery attempt details
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} deliveryId Webhook delivery ID (ULID)
         * @param {string} attemptId Delivery attempt ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookDeliveryAttemptDetails(partnerId: string, deliveryId: string, attemptId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookDeliveryAttemptDetailResponse> {
            return localVarFp.getWebhookDeliveryAttemptDetails(partnerId, deliveryId, attemptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed information about a specific webhook delivery, including all delivery attempts and response data.
         * @summary Get webhook delivery details
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} deliveryId Webhook delivery ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookDeliveryDetails(partnerId: string, deliveryId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookDeliveryDetailResponse> {
            return localVarFp.getWebhookDeliveryDetails(partnerId, deliveryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve consolidated monitoring dashboard data combining health checks, active alerts, and summary metrics.
         * @summary Get webhook monitoring dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookMonitoringDashboard(options?: RawAxiosRequestConfig): AxiosPromise<WebhookMonitoringDashboard> {
            return localVarFp.getWebhookMonitoringDashboard(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all active webhook delivery alerts including severity, affected endpoints, and descriptive metadata.
         * @summary List active webhook delivery alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveWebhookAlerts(options?: RawAxiosRequestConfig): AxiosPromise<Array<DeliveryAlert>> {
            return localVarFp.listActiveWebhookAlerts(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve active delivery alerts scoped to a specific partner webhook configuration.
         * @summary List active alerts for partner webhook
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerWebhookAlerts(partnerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DeliveryAlert>> {
            return localVarFp.listPartnerWebhookAlerts(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of webhook delivery attempts for the authenticated partner. Results are sorted by creation date in descending order (most recent first). Uses standard page-based pagination.
         * @summary List webhook deliveries for partner
         * @param {string} partnerId Partner ID (ULID)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {string} [webhookId] Filter by specific webhook configuration ID
         * @param {ListWebhookDeliveriesStatusEnum} [status] Filter by delivery status
         * @param {string} [eventType] Filter by webhook event type
         * @param {string} [from] Filter deliveries from this date (ISO 8601 format)
         * @param {string} [to] Filter deliveries until this date (ISO 8601 format)
         * @param {string} [paymentSessionId] Filter by the payment session the webhook event is about
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebhookDeliveries(partnerId: string, page?: number, size?: number, webhookId?: string, status?: ListWebhookDeliveriesStatusEnum, eventType?: string, from?: string, to?: string, paymentSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<PagedWebhookDeliveryResponse> {
            return localVarFp.listWebhookDeliveries(partnerId, page, size, webhookId, status, eventType, from, to, paymentSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a complete history of delivery attempts for a specific webhook delivery. Attempts are ordered chronologically (latest first) with comprehensive troubleshooting information.
         * @summary List webhook delivery attempts
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} deliveryId Webhook delivery ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebhookDeliveryAttempts(partnerId: string, deliveryId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookDeliveryAttemptHistoryResponse> {
            return localVarFp.listWebhookDeliveryAttempts(partnerId, deliveryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve an active webhook alert with optional resolution details for audit trails.
         * @summary Resolve webhook delivery alert
         * @param {string} alertId Alert ID (ULID)
         * @param {AlertResolutionRequest} [alertResolutionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveWebhookAlert(alertId: string, alertResolutionRequest?: AlertResolutionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AlertResolutionResponse> {
            return localVarFp.resolveWebhookAlert(alertId, alertResolutionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Force a fresh partner webhook health check, bypassing cached results.
         * @summary Trigger partner webhook health check
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerPartnerWebhookHealthCheck(partnerId: string, options?: RawAxiosRequestConfig): AxiosPromise<PartnerHealthCheckTriggerResponse> {
            return localVarFp.triggerPartnerWebhookHealthCheck(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Force a fresh system-wide webhook health check, clearing cached aggregates.
         * @summary Trigger system-wide webhook health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSystemWebhookHealthCheck(options?: RawAxiosRequestConfig): AxiosPromise<SystemHealthCheckTriggerResponse> {
            return localVarFp.triggerSystemWebhookHealthCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhookMonitoringApi - object-oriented interface
 * @export
 * @class WebhookMonitoringApi
 * @extends {BaseAPI}
 */
export class WebhookMonitoringApi extends BaseAPI {
    /**
     * Remove resolved alerts older than 24 hours and return before/after statistics.
     * @summary Cleanup resolved webhook alerts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public cleanupWebhookAlerts(options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).cleanupWebhookAlerts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clear cached health check results to ensure subsequent checks recompute metrics.
     * @summary Clear webhook health check caches
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public clearWebhookHealthCheckCache(options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).clearWebhookHealthCheckCache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run a detailed health assessment for a partner webhook endpoint including connectivity, latency, reliability, and volume checks.
     * @summary Perform partner webhook health check
     * @param {string} partnerId Partner ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public getPartnerWebhookHealthCheck(partnerId: string, options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).getPartnerWebhookHealthCheck(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Execute a comprehensive health check across all partner webhook endpoints including aggregated metrics and system issues.
     * @summary Perform system-wide webhook health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public getSystemWebhookHealthCheck(options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).getSystemWebhookHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve aggregated statistics for active webhook alerts across the system.
     * @summary Get webhook alert statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public getWebhookAlertStatistics(options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).getWebhookAlertStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed information about a specific webhook delivery attempt, including comprehensive troubleshooting information, error details, and retry scheduling.
     * @summary Get webhook delivery attempt details
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} deliveryId Webhook delivery ID (ULID)
     * @param {string} attemptId Delivery attempt ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public getWebhookDeliveryAttemptDetails(partnerId: string, deliveryId: string, attemptId: string, options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).getWebhookDeliveryAttemptDetails(partnerId, deliveryId, attemptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed information about a specific webhook delivery, including all delivery attempts and response data.
     * @summary Get webhook delivery details
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} deliveryId Webhook delivery ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public getWebhookDeliveryDetails(partnerId: string, deliveryId: string, options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).getWebhookDeliveryDetails(partnerId, deliveryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve consolidated monitoring dashboard data combining health checks, active alerts, and summary metrics.
     * @summary Get webhook monitoring dashboard data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public getWebhookMonitoringDashboard(options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).getWebhookMonitoringDashboard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all active webhook delivery alerts including severity, affected endpoints, and descriptive metadata.
     * @summary List active webhook delivery alerts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public listActiveWebhookAlerts(options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).listActiveWebhookAlerts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve active delivery alerts scoped to a specific partner webhook configuration.
     * @summary List active alerts for partner webhook
     * @param {string} partnerId Partner ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public listPartnerWebhookAlerts(partnerId: string, options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).listPartnerWebhookAlerts(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of webhook delivery attempts for the authenticated partner. Results are sorted by creation date in descending order (most recent first). Uses standard page-based pagination.
     * @summary List webhook deliveries for partner
     * @param {string} partnerId Partner ID (ULID)
     * @param {number} [page] The zero-based index of the page of results to return.
     * @param {number} [size] The maximum number of results to return in a page.
     * @param {string} [webhookId] Filter by specific webhook configuration ID
     * @param {ListWebhookDeliveriesStatusEnum} [status] Filter by delivery status
     * @param {string} [eventType] Filter by webhook event type
     * @param {string} [from] Filter deliveries from this date (ISO 8601 format)
     * @param {string} [to] Filter deliveries until this date (ISO 8601 format)
     * @param {string} [paymentSessionId] Filter by the payment session the webhook event is about
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public listWebhookDeliveries(partnerId: string, page?: number, size?: number, webhookId?: string, status?: ListWebhookDeliveriesStatusEnum, eventType?: string, from?: string, to?: string, paymentSessionId?: string, options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).listWebhookDeliveries(partnerId, page, size, webhookId, status, eventType, from, to, paymentSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a complete history of delivery attempts for a specific webhook delivery. Attempts are ordered chronologically (latest first) with comprehensive troubleshooting information.
     * @summary List webhook delivery attempts
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} deliveryId Webhook delivery ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public listWebhookDeliveryAttempts(partnerId: string, deliveryId: string, options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).listWebhookDeliveryAttempts(partnerId, deliveryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve an active webhook alert with optional resolution details for audit trails.
     * @summary Resolve webhook delivery alert
     * @param {string} alertId Alert ID (ULID)
     * @param {AlertResolutionRequest} [alertResolutionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public resolveWebhookAlert(alertId: string, alertResolutionRequest?: AlertResolutionRequest, options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).resolveWebhookAlert(alertId, alertResolutionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Force a fresh partner webhook health check, bypassing cached results.
     * @summary Trigger partner webhook health check
     * @param {string} partnerId Partner ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public triggerPartnerWebhookHealthCheck(partnerId: string, options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).triggerPartnerWebhookHealthCheck(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Force a fresh system-wide webhook health check, clearing cached aggregates.
     * @summary Trigger system-wide webhook health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookMonitoringApi
     */
    public triggerSystemWebhookHealthCheck(options?: RawAxiosRequestConfig) {
        return WebhookMonitoringApiFp(this.configuration).triggerSystemWebhookHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListWebhookDeliveriesStatusEnum = {
    Pending: 'PENDING',
    Delivered: 'DELIVERED',
    Failed: 'FAILED',
    Retrying: 'RETRYING',
    DeadLetter: 'DEAD_LETTER'
} as const;
export type ListWebhookDeliveriesStatusEnum = typeof ListWebhookDeliveriesStatusEnum[keyof typeof ListWebhookDeliveriesStatusEnum];
